import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import { Dialog } from "../Dialog/Dialog";
import { DialogContent } from "../Dialog/DialogContent";
import { DialogFooter } from "../Dialog/DialogFooter";
import { Card } from "../../Cards/Card/Card";
import { GridContainer } from "../../Layout/Grid/GridContainer";
import { GridItem } from "../../Layout/Grid/GridItem";
import { DropDownMenu } from "../../Inputs/DropDownMenu/DropDownMenu";
import { ButtonBar } from "../../Buttons/ButtonBar/ButtonBar";
import { RightButtons } from "../../Buttons/ButtonBar/RightButtons";
import { Button } from "../../Buttons/Button/Button";
import { ILanguage, Localisation } from "@iconics/localisation";
import ToolkitTranslations from '@monza/toolkit/common/localization/translation';
import AssetControlsTranslations from '@monza/asset-controls/localization/translation';

export class LanguageDialog extends BaseComponent<ILanguageDialogProps, ILanguageDialogState>
{
    public static title= '';
    public static subTitle= '';
    public static languageInputLabel= '';
    public static okButtonLabel= '';
    public static cancelButtonLabel= '';

    constructor(props: ILanguageDialogProps)
    {
        super(props);
        this.state = {
            languages: [],
            selectedLanguageCode: '',
        };
    }

    public componentDidMount(): void
    {
        this.loadLanguages();
    }

    public async componentDidUpdate(prevProps: ILanguageDialogProps): Promise<void>
    {
        if (prevProps.open != this.props.open && this.props.open == true)
        {
            await this.handleOpen();
        }
    }

    private async handleOpen(): Promise<void>
    {
        const currentLanguage = await this.props.getCurrentLanguage();
        this.setState({ selectedLanguageCode: currentLanguage });
    }

    private loadLanguages(): void
    {
        const languages = this.props.localisation.languages.languages.filter(i => this.components.isDevMode || i.code != this.props.localisation.terms);
        this.setState({ languages: languages });
    }


    private handleLanguageChange(value: string): void
    {
        this.setState({ selectedLanguageCode: value });
    }

    private async handleSave(): Promise<void>
    {
        const { selectedLanguageCode } = this.state;
        await this.props.localisation.languages.setCurrent(selectedLanguageCode);
        ToolkitTranslations.currentLanguage = selectedLanguageCode;
        AssetControlsTranslations.currentLanguage = selectedLanguageCode;
        window.location.reload(); // ideally we would rerender the application rather than reloading
    }

    public render(): JSX.Element
    {
        return (
            <Dialog
                isOpen={this.props.open}
                onOpenChange={() => this.props.onClose()}
                width={4}
            >
                <DialogContent>
                    <Card
                        title={this.props.title ?? LanguageDialog.title}
                        subTitle={this.props.subTitle ?? LanguageDialog.subTitle}
                    >
                        <GridContainer>
                            <GridItem>
                                <DropDownMenu
                                    label={this.props.languageInputLabel ?? LanguageDialog.languageInputLabel}
                                    placeholder={this.props.languageInputLabel ?? LanguageDialog.languageInputLabel}
                                    onSelect={e => this.handleLanguageChange(e.value)}
                                    items={this.state.languages.map(i => ({ value: i.code, label: i.text(), icon: i.icon }))}
                                    selectedValue={this.state.selectedLanguageCode}
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </DialogContent>
                <DialogFooter>
                    <ButtonBar>
                        <RightButtons>
                            <Button
                                styleType='outlined'
                                onClick={() => this.props.onClose()}
                            >
                                {this.props.cancelButtonLabel ?? LanguageDialog.cancelButtonLabel}
                            </Button>
                            <Button
                                styleType='filled'
                                onClick={() => this.handleSave()}
                            >
                                {this.props.okButtonLabel ?? LanguageDialog.okButtonLabel}
                            </Button>
                        </RightButtons>
                    </ButtonBar>
                </DialogFooter>
            </Dialog>
        );
    }
}

export interface ILanguageDialogProps
{
    localisation: Localisation;
    title?: string;
    subTitle?: string;
    languageInputLabel?: string;
    cancelButtonLabel?: string;
    okButtonLabel?: string;
    open: boolean;
    onClose: () => void;
    getCurrentLanguage: () => Promise<string>;
}

export interface ILanguageDialogState
{
    languages: ILanguage[];
    selectedLanguageCode: string;
}
